import { FC } from 'react';

import { useTranslate } from 'hooks/useTranslate';

import { TradingOfferOperationsProvider } from 'modules/trading/components/TradingOfferOperations/context/TradingOfferOperationsContext';
import { useEquityMarketAdminPanel } from '../context/EquityMarketAdminPanelContext';
import TradingOfferOperations from '../../../components/TradingOfferOperations';
import { tabs } from '../constants/Tabs';

const OperationsTab: FC = () => {
  const { t } = useTranslate();

  const { data } = useEquityMarketAdminPanel();

  const isActive = data.selectedTab === tabs.OPERATIONS;

  return (
    <div
      className={`tab-pane fade ${isActive ? 'show active' : ''}`}
      role="tabpanel"
    >
      <div className="card card-bordered mb-4">
        <div className="card-inner">
          <h6 className="card-title mb-3">
            <em className="icon ni ni-list text-primary mr-2" />
            {t('AllOperations')}
          </h6>
          <p className="text-soft fs-13px mb-4">
            {t('OperationsTabDescription')}
          </p>
          <TradingOfferOperationsProvider>
            <TradingOfferOperations />
          </TradingOfferOperationsProvider>
        </div>
      </div>
    </div>
  );
};

export default OperationsTab;
